import React, { Component } from 'react';
import {Row, Col, Input, InputNumber} from 'antd'
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withActions } from 'actionware';
import _, { debounce } from 'lodash';
import * as numeral from 'numeral';
import { moneyFormat } from '../../../common/constants';
import { isEmpty } from 'lodash';

import '../fundingLimit.less'
import { ACTION_MAPPING, LIMIT_PLACEHOLDER, LENDER_RANK_PLACEHOLDER, DEFAULT_FUNDING_LIMIT_INPUT_AMOUNT_OBJECT } from '../constants';
import AmountCard from './allotedDisbursedCard';
import { validateProductAndLenderInputNumber } from './utils'
class LenderRankCard extends Component {

    constructor() {
        super();
        this.state = {
            rank: '',
            ...DEFAULT_FUNDING_LIMIT_INPUT_AMOUNT_OBJECT
        }
        this.debounceInputChange = debounce(this.debounceInputChange, 300);
    }

    componentDidMount() {
        const {lenderRankDetails} = this.props;
        this.setState({
            rank: lenderRankDetails.rank,
            inputAmount: lenderRankDetails.lender_limit_snapshot
        })
    }

    debounceInputChange = (action, productCode, lenderID, targetValue) => {
        this.props.handleInputFieldChange(action, productCode, lenderID, targetValue)
    }

    handleRankChange = (e) => {
        const {productCode, lenderRankDetails: {lender_id}} =  this.props
        if (!this.props.isEditLenderRanking || this.props.lenderRankDetails.can_fund){
            this.setState({
                rank: e.target.value
            })
    
            //const errors = validateRankData(e.target.value, productLender, lender_id)
    
            //TODO: add validations here
            // if(errors.length <= 0) {
            //     this.debounceInputChange(ACTION_MAPPING.saveLenderRank, productCode, lender_id, e.target.value)
            // } else {
            //     //show UI for invalid rank values
    
            //     console.log(errors)
            // }
            
            this.debounceInputChange(ACTION_MAPPING.saveLenderRank, productCode, lender_id, e.target.value)
        }
    }

    handleLenderLimitChange = (limitValue) => {
        const {productCode, lenderRankDetails: {lender_id}, translate} =  this.props
        this.setState({
            ...DEFAULT_FUNDING_LIMIT_INPUT_AMOUNT_OBJECT,
            inputAmount: limitValue
        })
        const errorMessage = validateProductAndLenderInputNumber(limitValue, translate)
        if(!isEmpty(errorMessage)){
            this.setState({
                isCurrentInputAmountInvalid: true,
                currentInvalidInputAmountMessage: errorMessage
            })
        }
        this.debounceInputChange(ACTION_MAPPING.saveLimit, productCode, lender_id, limitValue)
    }

    renderInputNumberComponent = () => {
        const invalidInputNumberClass = this.props.isInvalidInputAmount || this.state.isCurrentInputAmountInvalid ? "lender-rank-card-inputnumber-error" : ''
        return (
            <Row className={`lender-rank-card-inputnumber ${invalidInputNumberClass}`}>
                <InputNumber
                    className='lender-rank-card-inputnumber-style'
                    placeholder={LIMIT_PLACEHOLDER}
                    onChange={this.handleLenderLimitChange}
                    value={this.state.inputAmount === -1 ? '' : this.state.inputAmount}
                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                    parser={value => value.replace(/\$\s?|(\.*)/g, '')}
                />
            </Row>
        );
        
    };
    renderInputNumberErrorMessage = () => {
        const {isInvalidInputAmount, isInvalidInputAmountMessage} = this.props
        const {isCurrentInputAmountInvalid, currentInvalidInputAmountMessage} = this.state
        return (
            <>
                {isInvalidInputAmount ? <div className='lender-rank-card-input-error'>{isInvalidInputAmountMessage}</div> : <></>}
                {isCurrentInputAmountInvalid && !isInvalidInputAmount ? <div className='lender-rank-card-input-error'>{currentInvalidInputAmountMessage}</div> : <></>}
            </>
        );
    }

    render() {
      const {lenderRankDetails, isInvalidInputRank, isInvalidInputRankMessage, isEditLenderRanking} = this.props
      const inputRankClass = isEditLenderRanking && !lenderRankDetails.can_fund ? 'greyed-out' : ''
      const invalidInputRankClass = isInvalidInputRank ? "lender-rank-card-input-priority-style-error" : ''
      const inputRankCanFundClass = !lenderRankDetails.can_fund && isEditLenderRanking ? "lender-rank-card-container-shadow" : ''
      return (
       <Row key={lenderRankDetails.lender_id} type='flex' align='middle' className={`lender-rank-card-container ${inputRankCanFundClass}`}>
            <Col span={2}>
                <Input
                    key={lenderRankDetails.lender_id}
                    className={`lender-rank-card-input-priority-style ${invalidInputRankClass} ${inputRankClass}`}
                    placeholder={LENDER_RANK_PLACEHOLDER}
                    disabled={isEditLenderRanking && !lenderRankDetails.can_fund}
                    onChange={this.handleRankChange}
                    value={this.state.rank === -1 ? '' : this.state.rank}
                />
                {isInvalidInputRank ? <div className='lender-rank-card-input-priority-error'>{isInvalidInputRankMessage}</div> : <></>}
            </Col>
            {/* <Col span={1}>
                <span className='lender-rank-card-icon-arrow'>
                    <InlineSVG src={arrowUpIcon} width={16} height={16}/>
                </span>
            </Col>
            <Col span={1}>
                <span className='lender-rank-card-icon-arrow'>
                    <InlineSVG src={arrowDownIcon} width={16} height={16}/>
                </span>
            </Col> */}
            <Col span={8}>
                {lenderRankDetails.lender_name}
            </Col>
            <Col span={8} offset={6}>
                {this.props.isEditLenderRanking ? <AmountCard cardData = {{...lenderRankDetails}} {...this.props}/> :  this.renderInputNumberComponent() }
                {this.renderInputNumberErrorMessage()}
            </Col>
       </Row>
      );
    }
  }

  @connect(
    ({ localize }) => ({
      translate: getTranslate(localize),
    })
  )
  @withActions({})
  export default class LenderRank extends Component {
    render() {
        const {productLender, translate, isTotalAmountExceeded, isTotalAmountExceededMessage, lenderRankAllValidations, isEditLenderRanking} = this.props
        const lenderKeys = _.keys(productLender.lenders)
        const totalAmount = productLender.product_limit_snapshot
        return (
            <div key={productLender.code} className='lender-rank-container'>
                <Row className='lender-rank-title'>
                    <Col span={12}> {translate('fundingLimit.ovo_admin_heading_total_funds_by_type_funding_limit').replace("${productName}", productLender.product_name)} </Col>
                    <Col className='lender-rank-title-col-2'>
                        <span>{totalAmount && totalAmount !== '-' ?  numeral(totalAmount).format(moneyFormat) : totalAmount}</span>
                    </Col>
                </Row>
                {lenderKeys.map((lenderKey) => {
                    return (
                    <LenderRankCard 
                        productID = {productLender.product_id}
                        productCode = {productLender.code} 
                        lenderRankDetails = {productLender.lenders[lenderKey]}
                        title = {translate('fundingLimit.alloted')} 
                        translate={translate}
                        isEditLenderRanking={isEditLenderRanking}
                        isInvalidInputAmount={this.props.lenderRankAllValidations.has(lenderKey) ? this.props.lenderRankAllValidations.get(lenderKey).isInvalidInputAmount : false}
                        isInvalidInputAmountMessage={this.props.lenderRankAllValidations.has(lenderKey) ? this.props.lenderRankAllValidations.get(lenderKey).isInvalidInputAmountMessage : false} 
                        isInvalidInputRank={this.props.lenderRankAllValidations.has(lenderKey) ? this.props.lenderRankAllValidations.get(lenderKey).isInvalidInputRank : false} 
                        isInvalidInputRankMessage={this.props.lenderRankAllValidations.has(lenderKey) ? this.props.lenderRankAllValidations.get(lenderKey).isInvalidInputRankMessage : false}  
                        {...this.props} 
                    />
                    )
                })}
                {isTotalAmountExceeded ? <div className='lender-rank-container-error-style'>{isTotalAmountExceededMessage}</div> : <></>}
            </div>
        );
    }
  }